import { render, staticRenderFns } from "./product-location-attribute.vue?vue&type=template&id=81eb915c"
import script from "./product-location-attribute.vue?vue&type=script&lang=js"
export * from "./product-location-attribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports